import { CampaignType } from '../../model/schema'

export const CAMPAIGN_DETAIL = {
  id: 1,
  type: CampaignType.EVENT,
  code: 'event_appreview',
  title: '앱 리뷰 이벤트',
  description: '',
  link: 'https://33m2-hub.link/landing/event_appreview',
  image: 'campaign/5b71cfe5-c5bd-4954-9219-abe9d2def06b.png',
  categoryId: 7,
  categoryName: '임차인 이벤트',
}
